import { Component } from 'react';
import PropTypes from 'prop-types';
import * as Sentry from "@sentry/browser";
import { connect } from 'react-redux';
import get from 'lodash/get';

// Redux
import store from './store';
import { showNormalNotification } from '../redux/actions/notificationsActions';
import { simpleId } from '../libs/utils';

const notification = params => store.dispatch(showNormalNotification({ ...params }));

// :TODO:: Add client
class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null, errorInfo: null };

  } // END constructor

  componentDidCatch(error, errorInfo) {
    const trackingCode = simpleId();
    const { appUser } = this.props;
    this.setState({
      error        : error,
      errorInfo    : errorInfo,
      trackingCode : trackingCode

    }); // END setState

    error.trackingCode = trackingCode;

    Sentry.withScope(scope => {
      console.warn(`DEBUG -> Generating error report with trackingCode: ${trackingCode}`);
      scope.setTag("transaction_id", trackingCode);
      Object.keys(errorInfo).forEach(key => scope.setExtra(key, errorInfo[key]));

      // User
      Sentry.setUser({ id: get(appUser, 'team.uuid', ''), email: get(appUser, 'email', '')});

      // Errors
      Sentry.captureException(error);

    }); // Sentry.withScope

  } // END componentDidCatch

  async shouldComponentUpdate(nextProps, nextState){
    if (nextState.error) {
      const { trackingCode } = nextState.error;

      await notification({
        color    : 'danger',
        message  : `Ocurrió un error, si el problema persiste, limpia el cache de tu navegador e intente de nuevo o más tarde. Se ha realizdo un reporte automático con el código: ${trackingCode}`,
        duration : 10,
        unique   : true
      }); // END notification

      await notification({
        color    : 'danger',
        message  : `Ocurrió un error, si el problema persiste, limpia el cache de tu navegador e intente de nuevo o más tarde. Se ha realizdo un reporte automático con el código: ${trackingCode}`,
        duration : 10,
        unique   : true
      }); // END notification
    } // END if
    return true
  }; // END shouldComponentUpdate

  render() {
    return this.props.children
  } // END render
} // END ErrorBoundary

ErrorBoundary.propTypes = {
  children: PropTypes.node,
  appUser: PropTypes.any,
};

export default connect(state => ({
  appUser: state.account,
}), null )(ErrorBoundary);



// WEBPACK FOOTER //
// ./src/app/ErrorBoundary.js